var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChecked = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_820_4489",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_820_4489)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.33344 11.9007L13.5609 6.6651C13.6759 6.54983 13.8048 6.49219 13.9476 6.49219C14.0905 6.49219 14.2197 6.54969 14.3351 6.66469C14.4504 6.77969 14.508 6.90865 14.508 7.05156C14.508 7.19462 14.4504 7.32385 14.3351 7.43927L8.79823 12.968C8.66142 13.1048 8.50302 13.1732 8.32302 13.1732C8.14302 13.1732 7.98462 13.1048 7.84781 12.968L5.6651 10.7934C5.54983 10.6784 5.49219 10.5495 5.49219 10.4068C5.49219 10.2639 5.54969 10.1347 5.66469 10.0193C5.77969 9.90399 5.90865 9.84635 6.05156 9.84635C6.19462 9.84635 6.32385 9.90399 6.43927 10.0193L8.33344 11.9007Z",
  fill: "currentColor"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChecked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "5107cdc0c7846e772653fff9c7a03104.svg";